export default __webpack_public_path__ + "static/media/IMG-20250105-WA0034.d48db62e.jpg";